/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { SmtpSettingActionTypes } from '../../action/auto_action/SmtpSettingActions'
import { SmtpSettingState } from '../state/SmtpSettingState'

class SmtpSettingStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new SmtpSettingState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SmtpSettingActionTypes.fetchOne:
        return state.merge(payload)

      case SmtpSettingActionTypes.onCreate:
        return state.clear()

      case SmtpSettingActionTypes.onEdit:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new SmtpSettingStore()
